import React, { useEffect, useState } from "react";
import {AddButton, CancelButton, SaveAndUpdate } from "../../utils/commonComponent/Custom/Button";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate, useParams } from "react-router-dom";
import { fetchQuery } from "../../utils/commonComponent/fetched";
import DeleteIcon from "@mui/icons-material/Delete";
import { Table, TableBody, TableCell, TableHead, TableRow, TextField} from "@mui/material";
import MultiAddressInput, { onSubmitAddress } from "./MultiAddressInput";
import { toast } from "react-toastify";
import axios from "axios";
import CommonForm from "../../utils/commonComponent/commonForm";
import Text from "../../utils/commonComponent/Custom/text";
import { BASE_URL, UnicodeCompany   } from "../../global";
import { statesList } from "../../utils/commonComponent/stateList";
import { ClassicTable } from "./ClassicTable";
import axiosWithToken from "../../utils/commonComponent/axiosTokenConfig";
import { getPermissions } from "../rbac/hasAccess";

const readingColumns = [
  {
    field: "id",
    headerName: "Sr.No.",
    editable: false,
  },
  {
    field: "dept",
    headerName: "Department",
    editable: true,
  },
  {
    field: "contactPersonName",
    headerName: "Contact Person Name",
    editable: true,
  },

  {
    field: "contactNo",
    headerName: "Contact No",
    editable: true,
    validate: (value) => /^\d{10}$/.test(value),
    errorText: "(10 digits required)",
  },
  {
    field: "email",
    headerName: "Email Id",
    editable: true,
    validate: (value) =>
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value),
    errorText: "Invalid email address",
  },
];

const EditClientMaster = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const navigate = useNavigate();
  const [inputStates, setInputStates] = React.useState({});
  const [contactDetailsRows, setContactDetailsRowsRows] = React.useState([]);
  const [addressIds, setAddressIds] = React.useState("");
  const [shippingAddressIds, setShippingAddressIds] = React.useState("");
  const [allAddresses, setAllAddresses] = React.useState([]);
  const [districtOptions, setDistrictOptions] = React.useState([]);
  const [branches, setBranches] = React.useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);

  const updateCellValue = (rowIndex, colIndex, value) => {
    const newRows = [...contactDetailsRows];
    newRows[rowIndex][colIndex] = value;
    setContactDetailsRowsRows([...newRows]);
  };

  const addRangeRow = () => {
    let newReadingRows = [...contactDetailsRows];
    newReadingRows.push(["", "", "", ""]);
    setContactDetailsRowsRows([...newReadingRows]);
  };

  const deleteReadingRow = (rowIndex) => {
    let newReadingRows = [...contactDetailsRows];
    if (newReadingRows[rowIndex] != undefined) {
      newReadingRows.splice(rowIndex, 1);
      setContactDetailsRowsRows([...newReadingRows]);
    }
  };
  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  const getClientLastID = async () => {
    try {
      const [lastClient] = await fetchQuery(`SELECT id, uniCode FROM clientMaster ORDER BY id DESC LIMIT 1`);
      const newUniCode = `${UnicodeCompany}${String(
        (parseInt(
          (lastClient?.uniCode || "").match(/\d+$/)?.[0] || "0", 10
        ) + 1)
          .toString()
          .padStart(3, "0")
      )}`;
      updateInputObject("uniCode", newUniCode);
    } catch (error) {
      console.error("Error fetching last client ID:", error);
    }
  };

  useEffect(() => {
    if (params.id == 0) {
      getClientLastID();
    }
  }, []);

  const fetchBranches = async (onDone) => {
    try {
      const res = await axiosWithToken.get(BASE_URL + "branch?_where=(status,eq,1)");
      const mapped = res.data.map((item) => ({
        id: item.id,
        branchName: item.branchName,
      }));
      setBranches(mapped);
      if (onDone) onDone(res.data);
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };

  const inputFields = [
    { type: "TextField", label: "Client Name *", stateKey: "companyName"},
    { type: "TextField", label: "Client Initial *", stateKey: "clientInitial"},
    {
      required: true,
      type: "Autocomplete",
      label: "Branch",
      stateKey: "branch",
      options: branches,
      valueKey: "id",
      getOptionLabelKey: "branchName",
      value: selectedBranch,
      onChange: (value) => setSelectedBranch(value),
    },
    { type: "TextField", label: "GST", stateKey: "gstNumber" },

    {
      type: "Autocomplete",
      label: "Site State",
      stateKey: "state",
      options: statesList,
      valueKey: "label",
      getOptionLabelKey: "label",
    },
    // {
    //   type: "Autocomplete",
    //   label: "Location",
    //   stateKey: "location",
    //   options: districtOptions,
    //   valueKey: "city",
    //   getOptionLabelKey: "city",
    // },
    { type: "TextField", label: "Vendor Code", stateKey: "vendorCode" },
    { type: "TextField", label: "UniCode", stateKey: "uniCode", disabled:true },
  ];

  const fetchClient = async () => {
    try {
      const [client] = await fetchQuery(`select * from clientMaster where id = ${params.id}`);
      setInputStates(client);
      setAddressIds(client.address);
      setShippingAddressIds(client?.shippingAddress);
      const contacts = client.contact?.trim() ? JSON.parse(client.contact) : [];
      let contactDetailsArray = contacts.map((c) => [
        c.dept,
        c.contactPersonName,
        c.contact,
        c.emailId,
      ]);
      setContactDetailsRowsRows(contactDetailsArray);

      fetchBranches((allBranchData) => {
        const tmp = {};
        allBranchData.forEach((b) => (tmp[b.id] = b));
        const resolvedBranch = client?.branch ? tmp[client.branch] || null : null;
        setInputStates((prev) => ({ ...prev, branch: resolvedBranch?.id || null }));
      });
    } catch (error) {
      console.error("Error fetching client:", error);
    }
  };

  const onSubmit = async () => {
    if (params.id == 0) {
      if (!inputStates?.companyName) {
        toast.error("Client Name is required");
        return;
      }
      if (!inputStates?.clientInitial) {
        toast.error("Client Initial is required");
        return;
      }
      if (!inputStates?.branch) {
        toast.error("Please select a branch");
        return;
      }
      if (!allAddresses[0]?.address) {
        toast.error("At least one address is required");
        return;
      }
      if (contactDetailsRows.length === 0) {
        toast.error("At least one contact is required");
        return;
      }
    }

    if (contactDetailsRows.length > 0) {
      let isValid = true;
      contactDetailsRows.forEach((row) => {
        if (!row[0] || !row[1] || !row[2] || !row[3]) {
          isValid = false;
        }
      });
      if (!isValid) {
        toast.error("All fields are required for each contact detail");
        return;
      }
    }

    try {
      const AllIds = await onSubmitAddress(
        allAddresses,
        setShippingAddressIds,
        setAddressIds
      );

      const rows = contactDetailsRows.map((row) => ({
        dept: row[0] || "",
        contactPersonName: row[1] || "",
        contact: row[2] || "",
        emailId: row[3] || "",
      }));

      const mergedRows = [...rows];

      const jsonData = {
        companyName: inputStates?.companyName || null,
        clientInitial: inputStates?.clientInitial || null,
        contact: mergedRows.length > 0 ? JSON.stringify(mergedRows) : null,
        address:
          addressIds && AllIds?.[0]
            ? `${addressIds},${AllIds?.[0]}`
            : addressIds || AllIds?.[0] || "",
        shippingAddress:
          shippingAddressIds && AllIds?.[1]
            ? `${shippingAddressIds},${AllIds?.[1]}`
            : shippingAddressIds || AllIds?.[1] || "",
        gstNumber: inputStates?.gstNumber || null,
        state: inputStates.state || null,
        email: inputStates.email || null,
        // location: inputStates.location || null,
        status: 1,
        vendorCode: inputStates?.vendorCode || null,
        uniCode: inputStates?.uniCode || null,
        branch: inputStates?.branch?.id || inputStates?.branch || null,
      };

      const url = BASE_URL + `clientMaster`;

      params.id == 0
        ? await axiosWithToken.post(url, jsonData)
        : await axiosWithToken.patch(url + `/${params.id}`, jsonData);

      toast.success(params.id == 0 ? "Client Created!" : "Clients Updated!");
      if (params.id == 0) {
        setTimeout(() => navigate("/master/client"), 1000);
      } else {
        setTimeout(() => window.location.reload(), 1000);
      }
    } catch (error) {
      console.log(error.message || "Something Went Wrong!");
    }
  };

  useEffect(() => {
    if (params.id != 0) {
      fetchClient(); 
    } else {
      fetchBranches(() => {});
    }
  }, []);

  // useEffect(() => {
  //     const selectedState = statesList.find(
  //       (s) => s.label === inputStates.state
  //     );
  //     if (selectedState?.district) {
  //       setDistrictOptions(selectedState.district);
  //     } else {
  //       setDistrictOptions([]);
  //     }
  // }, [inputStates.state]);

  return (
    <>
      <Text variant="h3" bold className="text-blue-600">
        {params.id == 0
          ? "Create New Client"
          : `Update Client ${inputStates?.companyName}`}
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={inputFields}
      />
      <br />
      <MultiAddressInput
        addressIds={addressIds}
        shippingAddressIds={shippingAddressIds}
        setAddressIds={setAddressIds}
        setShippingAddressIds={setShippingAddressIds}
        allAddresses={allAddresses}
        setAllAddresses={setAllAddresses}
        params={params}
        permissions={permissions}
      />
      <br />
      <br />
      <div className="flex justify-end mb-5">
        <AddButton
          id="btn-add-outline"
          label="Add Contact"
          icon={<AddIcon fontSize="small" />}
          onClick={(e) => {
            addRangeRow(0);
          }}
        />
      </div>
      <div style={{ width: "100%", overflow: "auto" }}>
        <ClassicTable>
          <Table sx={{ minWidth: 660 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                {readingColumns?.map((column) => (
                  <TableCell key={column.field}> {column.headerName}</TableCell>
                ))}
                {(permissions.delete || permissions.allAccess) && (
                  <TableCell>Actions</TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {contactDetailsRows.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  {row.map((cell, cellIndex) => (
                    <TableCell key={cellIndex}>
                      <TextField
                        id="client_edit_contvalue"
                        size="small"
                        inputProps={{
                          autoComplete: "off",
                        }}
                        value={cell}
                        onChange={(e) => {
                          updateCellValue(index, cellIndex, e.target.value);
                        }}
                        type={cellIndex == 3 ? "email" : "text"}
                        inputMode={cellIndex == 2 ? "numeric" : undefined}
                        maxLength={cellIndex == 2 ? 10 : undefined}
                        error={
                          cell &&
                          readingColumns[cellIndex + 1].validate &&
                          !readingColumns[cellIndex + 1].validate(cell)
                        }
                        helperText={
                              cell &&
                          readingColumns[cellIndex + 1].errorText &&
                          !readingColumns[cellIndex + 1].validate(cell)
                            ? readingColumns[cellIndex + 1].errorText
                            : " "
                        }
                      />
                    </TableCell>
                  ))}
                  {(permissions.delete || permissions.allAccess) && (
                    <TableCell>
                      <DeleteIcon
                        id="client_edit_contdelte"
                        style={{ color: "#dc3545", cursor: "pointer" }}
                        onClick={(e) => {
                          deleteReadingRow(index);
                        }}
                      />
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </ClassicTable>
      </div>
      <br />
      <div className="flex gap-10 mt-5 justify-end ">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
        {(permissions.save || permissions.allAccess) &&(
          <SaveAndUpdate
            id="btn-add-outline"
            label={params.id == 0 ? "Save" : "Update"}
            onClick={onSubmit}
          />
        )}
      </div>
    </>
  );
};

export default EditClientMaster;
